import { HttpGateway } from "@shared-kernel/secondary/http-gateway";
import type { TokenStorageGateway } from "@shared-kernel/application/ports/token-storage-gateway";
import config from "../../../../config/backend";
import type { DocumentUploadContext, DocumentUploadProvider } from "@shared-kernel/application/ports/shared/document-upload-provider";
import { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

export class BackendDocumentUploadProvider extends HttpGateway implements DocumentUploadProvider {
  private _adminRoute: string = "v1/admin";
  private _teacherRoute: string = "v1/teacher";
  private _providerRoute: string = "v1/provider";
  private _studentRoute: string = "v1/student";
  constructor(tokenStorageGateway: TokenStorageGateway) {
    super(config.url, tokenStorageGateway);
  }

  private resolveBaseRoute(context: DocumentUploadContext): string {
    if (context.asAdmin) return this._adminRoute;
    switch (context.role) {
      case ROLES.TEACHER:
        return this._teacherRoute;
      case ROLES.PROVIDER:
        return this._providerRoute;
      case ROLES.STUDENT:
        return this._studentRoute;
      default:
        throw new Error(`Unhandled role: ${context.role}`);
    }
  }

  async uploadDocument(file: File, context: DocumentUploadContext): Promise<string> {
    const route = `${this.resolveBaseRoute(context)}/documents:upload`;
    const formDataBody = new FormData();
    formDataBody.append("document", file);

    const res = await this._instance.post(route, formDataBody);
    return res.data;
  }

  async uploadImage(file: File, context: DocumentUploadContext): Promise<string> {
    if (!context.asAdmin && context.role === ROLES.STUDENT) {
      throw new Error("Students cannot upload images");
    }
    const route = `${this.resolveBaseRoute(context)}/images:upload`;
    const formDataBody = new FormData();
    formDataBody.append("image", file);

    const res = await this._instance.post(route, formDataBody);
    return res.data;
  }
}
